export default __webpack_public_path__ + "static/media/Delete.45d4e10f.svg";